module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"back":"Voltar ao Shop","next":"Avançar"},"en-US":{"back":"Back to Shop","next":"Next"}}')
  delete Component.options._Ctor
}
